export type AnyRecord = Record<string, any>;

const DEFAULT_NESTED_KEYS = ['data', 'result', 'payload', 'content', 'user'];

export const parseObjectPayload = (value: unknown): AnyRecord | null => {
  if (value && typeof value === 'object') {
    return value as AnyRecord;
  }
  if (typeof value === 'string') {
    const text = value.trim();
    if (!text) return null;
    try {
      const parsed = JSON.parse(text);
      return parsed && typeof parsed === 'object'
        ? (parsed as AnyRecord)
        : null;
    } catch (_error) {
      return null;
    }
  }
  return null;
};

export const collectObjectCandidates = (
  input: unknown,
  nestedKeys: string[] = DEFAULT_NESTED_KEYS,
  maxDepth = 4,
): AnyRecord[] => {
  const root = parseObjectPayload(input);
  if (!root) return [];

  const result: AnyRecord[] = [root];
  const seen = new Set<AnyRecord>([root]);
  const queue: Array<{ value: AnyRecord; depth: number }> = [
    { value: root, depth: 0 },
  ];

  while (queue.length > 0) {
    const current = queue.shift();
    if (!current) {
      continue;
    }
    if (current.depth >= maxDepth) {
      continue;
    }

    nestedKeys.forEach((key) => {
      const nested = parseObjectPayload(current.value[key]);
      if (!nested || seen.has(nested)) {
        return;
      }
      seen.add(nested);
      result.push(nested);
      queue.push({
        value: nested,
        depth: current.depth + 1,
      });
    });
  }

  return result;
};
